export const ASSIGNMENTS_TYPES = [
    { id: 1, name: '3 Star', type: '3_STAR', total: 3},
    { id: 2, name: '5 Star', type: '5_STAR', total: 5},
    { id: 3, name: 'Letter Grade', type: 'ABCDF', total: 100},
    { id: 4, name: 'Pass / Fail', type: 'PASS_FAIL', total: 1},
    { id: 5, name: 'Numeric', type: 'NUMERIC', total: 100},
    { id: 99, name: 'Rubric', type: 'RUBRIC'},
];
